import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScriptLoaderService } from '../../../core/services/scriptloader.service';
import { TranslateService } from '@ngx-translate/core';
import { PaymentMethodResponseV1Dto } from '@frontend';

declare let HiPay: (config: { username: string; password: string; environment: string; lang: string }) => {
  create: (id: string, options: object) => HipayApplePayButton;
};
declare type HipayApplePayButton = {
  on: (evt: string, callback: (res: { token: string; brand: string }) => void) => void;
  completePaymentWithSuccess: () => void;
  completePaymentWithFailure: () => void;
};

function toString(val: string | number): string {
  return typeof val === 'number' ? val.toString() : val;
}

@Component({
  selector: 'app-apple-pay',

  template: `<div id="apple-pay-button"></div>`,
  styles: `
    :host {
      height: 40px;
      width: 120px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplePayComponent implements OnInit {
  @Input({ required: true }) paymentMethod: PaymentMethodResponseV1Dto;
  @Input({ required: true, transform: toString }) amount: string;
  @Input({ required: true }) currencyCode: string;
  @Output() cardInfo = new EventEmitter<{ token: string; paymentProduct: string }>();

  protected hipaySDKUrl = 'https://libs.hipay.com/js/sdkjs.js';
  constructor(
    private scriptLoaderService: ScriptLoaderService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.loadSDK();
  }

  loadSDK() {
    this.scriptLoaderService
      .load({
        name: 'hipay',
        src: this.hipaySDKUrl,
        loaded: false
      })
      .subscribe(() => {
        this.createApplePayButton();
      });
  }

  createApplePayButton() {
    const options = { ...this.paymentMethod.config.config.options };

    options.request.countryCode = 'SK'; // merchant's country code
    options.request.currencyCode = this.currencyCode;
    options.request.total = {
      label: this.translateService.instant('PAYMENT_COMPONENT.total'),
      amount: this.amount
    };
    options.selector = 'apple-pay-button';

    const applePayButton = HiPay({
      username: this.paymentMethod.config.credentials.username,
      password: this.paymentMethod.config.credentials.password,
      environment: this.paymentMethod.config.config.environment,
      lang: this.translateService.currentLang
    }).create('paymentRequestButton', options);

    applePayButton.on('paymentAuthorized', ({ token, brand }) => {
      this.cardInfo.emit({ token, paymentProduct: brand.toLowerCase() });
      applePayButton.completePaymentWithSuccess();
    });

    // Just close the system dialog, doing nothing
    applePayButton.on('cancel', () => {
      return;
    });

    // Close the system dialog, showing that the card auth failed (wrong fingerprint, etc.)
    applePayButton.on('paymentUnauthorized', () => {
      applePayButton.completePaymentWithFailure();
    });
  }
}
